<template>
  <div class="growup-main">
    <Header ref="head" :current="3" />
    <div class="growup-banner center">
      <img :src="getpath('growup/growupBanner', '.png?ran=1')" alt="">
    </div>
		<div class="bannerpad" :style="{backgroundImage:'url('+ getpath('growup/banner_padback','.png') +')'}">
			<img class="bannerinner" :src="getpath('/growup/banner_pad','.png')" alt="">
		</div>
    <div class="growup-module">
      <div class="growup-module-title center">
        <img class="line" :src="getpath('growup/line', '.png')" alt="">
        <img class="title" :src="getpath('growup/growupTitle_1', '.png')" alt="">
        <img class="button" @click="gotodown('growup')" :src="getpath('growup/experienceButton', '.png')" alt="">
      </div>
      <div class="growup-module-content center">
        <p>基于纸质童书，围绕家庭阅读展开的全场景化阅读服务产品，致力于带领孩子更好地领略童书世界，助力家长与孩子开启一段温暖的亲子阅读之旅。</p>
        <img class="book" :src="getpath('growup/book', '.png')" alt="">
      </div>
    </div>
    <div class="growup-module backcolor">
      <div class="growup-module-title center">
        <img class="line" :src="getpath('growup/line', '.png')" alt="">
        <img class="title" :src="getpath('growup/pictureBooks', '.png?r=1')" alt="">
      </div>
      <div class="growup-module-content center">
        <p>Uummii与21世纪出版社集团达成深度战略合作</p>
        <img class="cooperation" :src="getpath('growup/cooperation', '.png')" alt="">
        <p>共同带来</p>
        <p style="color:#ed8351">首套“书内扫码”即可体验配套阅读服务的</p>
        <div class="swiper">
          <img class="swiper-title" :src="getpath('growup/swiperTitle', '.png')" alt="">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>
              <img :src="getpath('growup/swiper_1', '.png?ran=1')" alt="">
            </swiper-slide>
            <swiper-slide>
              <img :src="getpath('growup/swiper_2', '.png?ran=1')" alt="">
            </swiper-slide>
            <swiper-slide>
              <img :src="getpath('growup/swiper_3', '.png?ran=1')" alt="">
            </swiper-slide>
            <swiper-slide>
              <img :src="getpath('growup/swiper_4', '.png?ran=1')" alt="">
            </swiper-slide>
            <swiper-slide>
              <img :src="getpath('growup/swiper_5', '.png?ran=1')" alt="">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <!-- <div class="button-group">
          <img class="button" :src="getpath('growup/buyButton', '.png')" alt="">
          <img class="button" :src="getpath('growup/downButton', '.png')" alt="">
        </div> -->
      </div>
    </div>
    <div class="growup-module">
      <div class="growup-module-title center">
        <img class="line" :src="getpath('growup/line', '.png')" alt="">
        <img class="title" :src="getpath('growup/growupTitle_2', '.png')" alt="">
      </div>
      <div class="growup-module-content">
        <img class="mock" :src="getpath('growup/mock', '.png?ra=1')" alt="">
      </div>
    </div>
    <div class="growup-botton">
      <img class="back" :src="getpath('growup/back', '.png?ra=1')" alt="">
      <div style="position:relative;height:100%" class="center">
        <img class="growup-slogan" :src="getpath('growup/growupSlogan', '.png')" alt="">
        <p class="slogan">体验童伴榜样阅读服务>>></p>
        <img class="qr" :src="getpath('growup/qr', '.png?r=2')" alt="">
        <img class="app" :src="getpath('growup/app', '.png')" alt="">
        <img class="ios" @click="downAPP('ios')" :src="getpath('growup/ios', '.png')" alt="">
        <img class="andriod" @click="downAPP('andriod')" :src="getpath('growup/andriod', '.png')" alt="">
      </div>
    </div>
    <Footer :color="'#F68D24'" />
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      swiperOptions:{
        pagination: {
          el: '.swiper-pagination'
        }
      }
    };
  },
  created(){
		document.title = 'Uummii-童伴成长'
  },
  methods:{
		downAPP(type){
			if(type == 'ios'){
				window.location.href = "https://apps.apple.com/cn/app/%E7%AB%A5%E4%BC%B4%E6%88%90%E9%95%BF-%E5%84%BF%E7%AB%A5%E9%98%85%E8%AF%BB%E5%90%AF%E8%92%99%E5%8F%8C%E8%AF%AD%E7%BB%98%E6%9C%AC/id1603195715";
			}else{
				window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=cn.stagekids.app.uugrowup.android"
			}
		}
  }
};
</script>

<style lang="scss" scoped>
.growup-main {
  width: 750px;
  margin: 0 auto;
  min-width: 414px;
  color: rgba(51, 51, 51, 1);
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  min-height: 100%;
  .growup-banner{
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bannerpad{
    width: 100%;
    text-align: center;
    background-size: 100% 100%;
    display: none;
    .bannerinner{
      width: 750px;
      bottom: 0%;
    }
  }
  .center{
    width: 100%;
    margin: 0 auto;
  }
  .growup-module{
    width: 100%;
    padding: 48px;
    box-sizing: border-box;
    .growup-module-title {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      width: 750px;
      .line {
        margin-right: 17px;
        width: 10px;
        height: 40px;
      }
      .title {
        margin-right: 30px;
        height: 40px;
      }
      .button {
        width: 138px;
      }
    }
    .growup-module-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      >p {
        font-size: 26px;
        font-weight: 500;
        text-align: justifyLeft;
        color: #282727;
        line-height: 38px;
        letter-spacing: 0px;
        padding-left: 27px;
      }
      .book {
        margin-top: 50px;
        width: 646px;
      }
      .cooperation {
        margin: 34px 0 32px 0;
        width: 490px;
      }
      .swiper{
        width: 600px;
        height: 400px;
        border-radius: 20px 20px 20px 20px;
        position: relative;
        margin-top: 50px;
        .swiper-title{
          position: absolute;
          z-index: 2;
          top: -25px;
          left: 84px;
          width: 431px;
        }
        img {
          width: 600px;
        }
      }
      .button-group {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 50px;
        .button {
          width: 188px;
        }
        .button:nth-child(1) {
          margin-right: 52px;
        }
        
      }
      .mock{
        width: 581px;
      }
    }
  }
  .growup-botton{
    position: relative;
    width: 100%;
    height: 457px;
    img {
      position: absolute;
    }
    .back{
      top: -105px;
      width: 100%;
    }
    .growup-slogan {
      top: 19px;
      left: 86px;
      width: 343px;
    }
    .qr {
      top: 78px;
      right: 86px;
      width: 137px;
    }
    .app {
      top: 155px;
      left: 86px;
      width: 265px;
    }
    .ios {
      top: 291px;
      left: 68px;
      width: 306px;
    }
    .andriod {
      top: 291px;
      left: 380px;
      width: 306px;
    }
    .slogan {
      position: absolute;
      top: 219px;
      left: 100px;
      font-weight: Medium;
      font-size: 26px;
      text-align: center;
      color: #000000 100%;
    }
  }
  .backcolor {
    background-color: #FEF7F4;
  }
}
	@media screen and (min-width: 750px) {
		.growup-main{
      width: 100%;
      padding-top: 50px;
      
      .center{
        width: 750px;
        margin: 0 auto;
      }
			.growup-banner{display: none;}
			.bannerpad{display: block;}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/growup.vue